import {logAudit} from "./logAudit";

export function openDatabase() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('myDatabase', 2);

        request.onupgradeneeded = event => {
            const db = event.target.result;
            if (db.objectStoreNames.contains('files')) {
                db.deleteObjectStore('files');
            }
            db.createObjectStore('files', { keyPath: 'id' });
        };

        request.onsuccess = event => {
            resolve(event.target.result);
        };

        request.onerror = event => {
            reject(event.target.error);
        };
    });
}
function normalizeId(id) {
    // NFC suele ser el más habitual en la web
    return id.normalize('NFC');
}

export function storeFile(rawId, file) {
    logAudit({
        state: 'INFO',
        message: 'nombre del archivo firmado:'+rawId,
        event: 'SIGN_PDF',
        args: { type: 'debug info' }
    });
    const id = normalizeId(rawId);
    return openDatabase().then(db => {
        return new Promise((resolve, reject) => {
            const tx = db.transaction(['files'], 'readwrite');
            const store = tx.objectStore('files');

            // 1) Intentamos borrar cualquier registro previo con la misma key
            const deleteReq = store.delete(id);
            deleteReq.onsuccess = () => {
                // 2) Una vez borrado (o si no existía), hacemos put()
                const putReq = store.put({ id, file });
                putReq.onsuccess = () => resolve();
                putReq.onerror   = event => reject(event.target.error);
            };
            deleteReq.onerror = event => {
                // Si falla el delete por alguna razón, seguimos con el put
                const putReq = store.put({ id, file });
                putReq.onsuccess = () => resolve();
                putReq.onerror   = e => reject(e.target.error);
            };
        });
    });
}


export function getFile(rawId) {
    const id = normalizeId(rawId);
    return openDatabase().then(db => {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(['files'], 'readonly');
            const store = transaction.objectStore('files');
            const request = store.get(id);

            request.onsuccess = event => {
                resolve(event.target.result ? event.target.result.file : null);
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    });
}

export const getFileSign = (rawId) => {
    const id = normalizeId(rawId);
    return openDatabase().then(db => {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(['files'], 'readonly');
            const store = transaction.objectStore('files');
            const request = store.get(id);

            request.onsuccess = event => {
                if (event.target.result) {
                    const base64File = event.target.result.file;
                    const binary = atob(base64File);
                    const array = [];
                    for (let i = 0; i < binary.length; i++) {
                        array.push(binary.charCodeAt(i));
                    }
                    const fileBlob = new Blob([new Uint8Array(array)], { type: 'application/pdf' });
                    resolve(fileBlob);
                } else {
                    reject('File not found');
                }
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    });
};

export function deleteFile(rawId) {
    const id = normalizeId(rawId);
    return openDatabase().then(db => {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(['files'], 'readwrite');
            const store = transaction.objectStore('files');
            const request = store.delete(id);

            request.onsuccess = () => {
                resolve();
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    });
}